export default __webpack_public_path__ + "static/media/post-img.866a670b.png";